// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__aAK5g","cardExpanded":"card_cardExpanded__3cnbX"};